import {createStore, applyMiddleware, compose} from 'redux'
import thunk from 'redux-thunk'
import reducer from './reducer'

import logger from 'redux-logger'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose

const enhancer = process.env.REACT_APP_ENV === "development" ? composeEnhancers(applyMiddleware(thunk,logger)) : ''
const store = createStore(reducer, enhancer)
export default store
